export default __webpack_public_path__ + "static/media/sky-bg-desktop@3x.1333ad3d.png";